import {graphql} from '~/graphql-react-query/';

export const ReportQuery = graphql(`
    query ReportQuery($id: UUID!) {
        reportV2 {
            report(id: $id) {
                id
                status
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                items {
                    id
                    name
                    type
                    description
                    definitionV2
                    teamId
                    createdAt
                    status
                    updateAt
                    userId
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                iconName
                iconColor
                country
            }
        }
    }
`);

export const ReportCreate = graphql(`
    mutation ReportCreate($input: ReportCreateInput!) {
        reportV2 {
            reportCreate(input: $input) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                items {
                    id
                }
                iconName
                iconColor
                country
                status
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
            }
        }
    }
`);

export const ReportUpdate = graphql(`
    mutation ReportUpdate($input: ReportUpdateInput!) {
        reportV2 {
            reportUpdate(input: $input) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                items {
                    id
                    userId
                    teamId
                    type
                    definitionV2
                    createdAt
                    updateAt
                    status
                    name
                    description
                }
                iconName
                iconColor
                sharing {
                    status
                    usersWithAccess {
                        name
                        id
                        email
                    }
                }
                status
                country
            }
        }
    }
`);

export const ReportRemove = graphql(`
    mutation ReportRemove($id: UUID!) {
        reportV2 {
            reportRemove(id: $id)
        }
    }
`);

export const ReportDuplicate = graphql(`
    mutation ReportDuplicate($id: UUID!) {
        reportV2 {
            reportDuplicate(id: $id) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                items {
                    id
                    userId
                    teamId
                    type
                    definitionV2
                    createdAt
                    updateAt
                    status
                    name
                    description
                }
                iconName
                iconColor
                sharing {
                    status
                    usersWithAccess {
                        name
                        id
                        email
                    }
                }
                status
                country
            }
        }
    }
`);

export const ReportList = graphql(`
    query ReportListV3Query($input: ReportListInput!) {
        reportV3 {
            reportList(input: $input) {
                items {
                    id
                    user {
                        id
                        name
                    }
                    teamId
                    status
                    teamName
                    name
                    description
                    iconName
                    iconColor
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                            email
                        }
                    }
                    createdAt
                    updatedAt
                    country
                }
                pagination {
                    page
                    count
                    hasNextPage
                }
            }
        }
    }
`);

export const ReportRemoveMany = graphql(`
    mutation ReportRemoveMany($ids: [UUID!]!) {
        reportV2 {
            reportRemoveMany(ids: $ids) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                iconName
                iconColor
                status
                sharing {
                    status
                    usersWithAccess {
                        name
                        id
                        email
                    }
                }
                country
            }
        }
    }
`);

export const ReportShareMany = graphql(`
    mutation ReportShareMany($input: ReportShareManyInput!) {
        reportV2 {
            reportShareMany(input: $input) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                createdAt
                updatedAt
                iconName
                iconColor
                status
                sharing {
                    status
                    usersWithAccess {
                        name
                        id
                        email
                    }
                }
                country
            }
        }
    }
`);

export const ReportSearch = graphql(`
    query ReportSearch($input: ReportSearchInput!) {
        reportV2 {
            reportSearch(input: $input) {
                id
                user {
                    id
                    name
                }
                teamId
                teamName
                name
                description
                iconName
                iconColor
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
                country
            }
        }
    }
`);

export const ReportItemCreate = graphql(`
    mutation ReportItemCreate($input: ReportItemV2CreateInput!) {
        reportV2 {
            reportItemCreate(input: $input) {
                id
                userId
                teamId
                type
                definitionV2
                createdAt
                updateAt
                status
                name
                description
            }
        }
    }
`);

export const ReportItemRemove = graphql(`
    mutation ReportItemRemove($input: ReportItemRemoveInput!) {
        reportV2 {
            reportItemRemove(input: $input)
        }
    }
`);

export const ReportItemUpdate = graphql(`
    mutation ReportItemUpdate($input: ReportItemV2UpdateInput!) {
        reportV2 {
            reportItemUpdate(input: $input) {
                id
                userId
                teamId
                type
                definitionV2
                createdAt
                updateAt
                status
                name
                description
            }
        }
    }
`);

export const PdfReportCreate = graphql(`
    mutation PdfReportCreateMutation($reportId: UUID!, $timezone: String, $printConfig: String) {
        pdfRenderer {
            pdfReportCreate(
                input: {
                    reportId: $reportId
                    timezone: $timezone
                    printConfig: $printConfig
                    debug: true
                }
            ) {
                downloadLink
            }
        }
    }
`);

export const PdfCreativeProfile = graphql(`
    mutation PdfCreativeProfileMutation(
        $filter: String!
        $appUrl: String!
        $timezone: String!
        $printConfig: String
    ) {
        pdfRenderer {
            pdfCreative(
                input: {
                    timezone: $timezone
                    filter: $filter
                    appUrl: $appUrl
                    printConfig: $printConfig
                    debug: true
                }
            ) {
                downloadLink
            }
        }
    }
`);
